import React from 'react';
import { IFormContext } from '../types/IFormContext';

const FormContext = React.createContext<IFormContext>({

});

const { Provider, Consumer } = FormContext;

export {
    Provider,
    Consumer
};

export default FormContext;